<template>
  <div class="view-contracts">
    <table class="table" v-if="contract">
      <tbody>
        <tr>
          <td class="label-col">Шаблон документа</td>
          <td v-if="contract.template">{{ contract.template.name }}</td>
        </tr>
        <tr v-if="contract.receiveListTemplate">
          <td>Шаблон акта возврата</td>
          <td >{{ contract.receiveListTemplate.name }}</td>
        </tr>
        <tr>
          <td>Водитель</td>
          <td v-if="contract.driver">{{ contract.driver.last_name }} {{ contract.driver.first_name }} {{ contract.driver.middle_name }}</td>
        </tr>
        <tr>
          <td>Автомобиль</td>
          <td v-if="contract.car">{{ contract.car.brand }} {{ contract.car.model }} - {{ contract.car.registration_plate }}</td>
        </tr>
        <tr>
          <td>Организация</td>
          <td>{{ companyName }}</td>
        </tr>
        <tr>
          <td>Дата/ время передачи автомобиля</td>
          <td>{{ contract.transfer_datetime | diffForHumans}}</td>
        </tr>
        <tr>
          <td>Дата/ время возврата автомобиля</td>
          <td>{{ contract.receiving_datetime | diffForHumans}}</td>
        </tr>
        <tr v-if="contract.archived_at">
          <td>Дата/ время принятия автомобиля (фактическая)</td>
          <td>{{ contract.archived_at | diffForHumans}}</td>
        </tr>
        <tr>
          <td>Адрес выдачи</td>
          <td>{{ contract.transfer_spot }}</td>
        </tr>
        <tr>
          <td>Адрес возврата</td>
          <td>{{ contract.receiving_spot }}</td>
        </tr>
        <tr>
          <td>Арендная плата</td>
          <td>{{ contract.price }} &#8381;</td>
        </tr>
        <tr>
          <td>Период оплаты</td>
          <td>{{ contract.payment_period | formatedPeriod }}</td>
        </tr>
      </tbody>
    </table>
    <hr class="mb-4" />
  </div>
</template>

<script>
import { djsMixin } from '@/components/mixins/djsMixin'
export default {
  name: 'ContractRentView',
  props: ['contract', 'companies'],
  mixins: [djsMixin],
  computed: {
    companyName () {
      const currentCompany = this.companies.find(company => company.id === this.contract.company_id)
      return currentCompany ? currentCompany.name : ''
    }
  },
  filters: {
    formatedPeriod (period) {
      switch (period) {
        case 'day':
          return 'Посуточно'
        case 'month':
          return 'Помесячно'
        case 'year':
          return 'Год'
      }
      return ''
    }
  }
}
</script>
<style scoped>
  .view-contracts span {
    margin: 10px;
  }
  .view-contracts {
    margin-top: 4rem;
  }
  .label-col {
    width: 25%;
  }
</style>
